var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShareLinkAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61528 6.47095C4.54771 6.35669 4.48755 6.23853 4.43495 6.11726C4.21144 5.60194 4.12463 5.03049 4.18743 4.46355C4.26502 3.76318 4.56638 3.11061 5.04283 2.61131C5.32022 2.32072 5.64976 2.09017 6.01257 1.93286C6.37539 1.77555 6.76435 1.69458 7.15716 1.69458C7.54998 1.69458 7.93894 1.77555 8.30175 1.93286C8.66457 2.09017 8.99411 2.32072 9.2715 2.61131L13.8676 7.40619C14.4265 7.99451 14.7401 8.78979 14.7401 9.61868C14.7401 10.4476 14.4265 11.2429 13.8676 11.8312C13.3045 12.4151 12.5433 12.7427 11.7499 12.7427C10.9565 12.7427 10.1953 12.4151 9.63224 11.8312L8.17866 10.3068",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.437 13.6255C15.7634 14.2219 15.893 14.9139 15.8061 15.5948C15.7192 16.2758 15.4205 16.9081 14.956 17.3944C14.3941 17.9778 13.634 18.3053 12.8417 18.3053C12.0494 18.3053 11.2893 17.9778 10.7274 17.3944L6.13127 12.5925C5.57279 12.0054 5.25934 11.2113 5.25934 10.3835C5.25934 9.55576 5.57279 8.76164 6.13127 8.17451C6.69437 7.59061 7.45557 7.26294 8.24895 7.26294C9.04232 7.26294 9.80352 7.59061 10.3666 8.17451L11.8982 9.77466",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareLinkAction);
export default __webpack_public_path__ + "static/media/icon-share-link-action.6e5eccb06660b2fe81073c59b958c2ba.svg";
export { ForwardRef as ReactComponent };